import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const Actions = crudActions('post')

const create = (ctx, post) => {
  const formData = new FormData()
  const arr = [
    'status', 'title_uz', 'title_ru', 'title_en',
    'body_uz', 'body_ru', 'body_en',
  ]
  arr.forEach(field => {
    formData.append(field, post[field])
  })

  if (post.image instanceof File) formData.append('image', post.image)

  if (post.id) {
    return axios.patch(`/post/${post.id}/`, formData)
  }
  return axios.post('/post/', formData)
}
export default {
  ...Actions,
  create,
}
